let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lXnsR")).then(() => parcelRequire('fr01P'));